import axios from 'axios'

export default token =>
  axios.create({
    baseURL: process.env.VUE_APP_SERVER,
    timeout: 5000,
    headers: { 'x-placement-token': token }
  })
